module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 columns text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/logo-med.png"),
      "alt": ""
    }
  })])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 columns small-centered"
  }, [_c('error-callout', {
    attrs: {
      "error": _vm.error
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-3 columns small-centered text-center"
  }, [_c('p', [_c('br'), _vm._v("Hozzáférés engedélyezéséhez lépjen kapcsolatba az üzemeltetőkkel.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-890ff3b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Preregistered.vue
// module id = 486
// module chunks = 2